import controller from './HeaderNew.controller';
import templateUrl from '../Templates/header_new.html';

const HeaderNewComponent = {
  templateUrl,
  controller,
};

export default HeaderNewComponent;
